import { render } from "@testing-library/react";
import React, { useState, useEffect } from "react";
import styled from "styled-components";
import "./App.css";

import CloseQuarters from "./components/CloseQuarters";
import NewCloseQuarters from "./components/NewCloseQuarters";
import Offtolaces from "./components/Offtolaces";

import Headoverheels from "./components/Headoverheels";

import TheTippingPointTabs from "./components/TheTippingPointTabs";

import CaughtOffMudGuard from './components/CaughtOffMudGuard'
import SellingYourMidsole from "./components/SellingYourMidsole";
import NewMotherTongue from "./components/NewMotherTongue";
import GoodForOutsole from './components/GoodForOutsole';
import Header from './components/Header'

// import styled from 'styled-components';
import {colors, mediaQueries, fonts} from "./shared/config"

import InfluentialSneakerHeader from './components/InfluentialSneakerHeader'
import InfluentialSneakerContent from "./components/InfluentialSneakerContent";

import SneakerIMG from "./images/sneaker_img.png"
import SneakerIMG2 from "./images/sneaker_img2.png"
import SilverLining from "./components/SilverLining";
import MotherTongue from "./components/MotherTongue";
import LandingPage from "./components/LandingPage";
import NewLanding from "./components/NewLanding";

import fb from './images/socials/fb.svg'
import insta from './images/socials/Vector.svg'
import twitter from './images/socials/Vector-1.svg'
import tiktok from './images/socials/Subtract.svg'
import email from './images/socials/Subtract-1.svg'
import Nav from "./components/Nav";

const Container = styled("div")`
  display: flex;
  flex-direction: column;
  scroll-behavior: smooth;
  

`;

const Text = styled.p`
    font-family: ${fonts.text};
    color: black;
    line-height: 24px;
    font-size: 20px;
    text-align: center;
    padding: 6em 0;
    /* padding-bottom: 20px; */
    
    /* margin: 0; */
    /* margin-top: 10px; */
    /* margin-bottom: -100px; */
    padding-bottom: -100px;
    padding-top: 40px;
    /* padding-bottom: -1000px; */
    /* padding-top: 120px; */
    ${mediaQueries.mobile} {
        padding: 2em 0;
    }
`;

function App() {
  const [ data, setData ] = useState(null);
  const media = window.matchMedia('(max-width: 750px)');
  const [isMobile, setIsMobile] = useState(media.matches);
  media.addEventListener('change', () => {
  if (media.matches !== isMobile) {
    setIsMobile(media.matches);
  }
});
  
  useEffect(() => {
    fetch("https://kerckhoff.dailybruin.com/api/packages/flatpages/interactive.2021.sneaker-longterm")
      .then((res) => res.json())
      .then((res) => setData(res.data["article.aml"]));
  }, []);
  
  let anchorTags = ["IN CLOSE QUARTERS","A NEW MOTHER TONGUE","LACING UP", "HEAD OVER HEELS", "GOOD FOR OUTSOLE", "THE TIPPING POINT", "CAUGHT OFF MUDGUARD", "SELLING YOUR MIDSOLE", "A SILVER LINING"];

  
  return (
    (data &&
     <>
     {/* { } */}
     <Container>
      <Header/>
      
      {/* {!isMobile && <NewLanding title={data.title} byline={data.byline} credits={data.image_credit}/>} */}
      <NewLanding title={data.title} byline={data.byline} credits={data.image_credit}/>
      {/* <LandingPage/>  */}
      <Nav data={anchorTags}></Nav>
      <a name={anchorTags[0]}>
      <NewCloseQuarters data={data["in_close_quarters"]}/>
      </a>
      
      <a name={anchorTags[1]}>
      <NewMotherTongue id={anchorTags[1]}data={data["new_mother_tongue"]}></NewMotherTongue>
      </a>
      
      <a name={anchorTags[2]}>
      <Offtolaces id={anchorTags[2]} data={data["lacing_up"]}></Offtolaces>
      </a>
      
      <a name={anchorTags[3]}>
      <Headoverheels id={anchorTags[3]} data={data["head_over_heels"]}></Headoverheels>
      </a>
      
      <a name={anchorTags[4]}>
      <InfluentialSneakerHeader id={anchorTags[4]}/>
      </a>
      <Text>
      Sneakers mean a lot to people both inside and outside of the culture. Many sneakerheads, in fact, cite nostalgia as the main source of their infatuation with a particular type of shoe or brand.
      </Text>
      <GoodForOutsole data={data["good_for_the_outsole"]}/>
      
      <a name={anchorTags[5]}>
      <TheTippingPointTabs id={anchorTags[5]} data={data["the_tipping_point"]}/>
      </a>
      
      <a name={anchorTags[6]}>
      <CaughtOffMudGuard id={anchorTags[6]} data={data["caught_off_mudgaurd"]}/>
      </a>
      
      <a name={anchorTags[7]}>
      <SellingYourMidsole id={anchorTags[7]} data={data["selling_your_midsole"]}/>
      </a>
      
      <a name={anchorTags[8]}>
      <SilverLining id={anchorTags[8]} data={data["silver_lining"]}/>
      </a>
      
      <Footer>
        <h1>DAILY BRUIN</h1>
        <Socials>
          <a href="https://www.instagram.com/dailybruin" target="_blank"><img src={insta}/></a>
          <a href="https://www.facebook.com/dailybruin" target="_blank"><img src={fb}/></a>
          <a href="https://www.twitter.com/dailybruin" target="_blank"><img src={twitter}/></a>
          <a href="https://www.tiktok.com/@dailybruin" target="_blank"><img src={tiktok}/></a>
          <a href="http://eepurl.com/cFEiZX" target="_blank"><img src={email}/></a>
          <p>Built with Suzy’s ♥ in Kerckhoff 118 by {data.developer_credits}. Designed by {data.designer_credits}.</p>
				</Socials>
      </Footer>
      </Container> 
      
     </>)
  );
}

const Background = styled.div`
  background-color: ${colors.red};
  min-height: 100vh;
  padding: 2em 0;
`

const Footer = styled.div`
	background-color: black;
	height: auto;
	color: white;
	padding: 80px 0 40px 0;
  text-align: center;
	h1 {
		margin: 0;
		font-family: 'Times New Roman', Times, serif;
    font-size: 30px;
	}
  margin-bottom: 20px;
`


const Socials = styled.div`
  position: relative;
	margin-top: 20px;
  
	img {

    position: relative;
		margin: 0 20px;
	}
	p {
    position: relative;
		margin: 80px 20px;
		${mediaQueries.mobile} {
			margin: 50px 20px;
		}
	}
`

export default App;
